import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { InfoOption } from '@app/forms/subscription/components/info/info.component';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
  selector: 'rachat-amount-form',
  templateUrl: './rachat-amount-form.component.html',
  styleUrls: ['./rachat-amount-form.component.scss'],
  standalone: false,
})
export class RachatAmountFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo: InfoOption = { icon: 'info' };

  constructor(
    protected formConstructor: PrFormConstructor,
    protected subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  protected get formOptions(): any {
    return {};
  }

  ngOnInit(): void {
    this.subscriptionFacade.initForm(this, this.formOptions);
  }

  onSubmit() {
    this.subscriptionFacade.selectErrorInputAndScroll(this);
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
